<template lang="pug">
  modal(@closeModal='hideElement({ element: "sentInvitationsModal" })')
    .column.middle.center
      img.sent-img.m4-bottom-6(src='../../assets/il_invitation_sent.png' alt='sent trial invitations success')
      h1.title-medium.black.m4-bottom-3
        | {{ $t('trialInvite.invitationsSentTitle') }}
      h2.text-big.dark-gray
        | {{ $t('trialInvite.invitationsSentSubtitle') }}
</template>

<script>
import { mapActions } from 'vuex'

import Modal from '@/components/Modal'

export default {
  components: { Modal },
  methods: {
    ...mapActions([
      'hideElement'
    ])
  }
}
</script>

<style lang="scss" scoped>
.sent-img {
  height: 95px;
}
</style>
